"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliders = void 0;
const splide_1 = require("@splidejs/splide");
const splide_extension_auto_scroll_1 = require("@splidejs/splide-extension-auto-scroll");
const sliders = () => {
    let logos = document.getElementsByClassName('logos--slider');
    for (let i = 0; i < logos.length; i++) {
        new splide_1.default(logos[i], {
            perPage: 8,
            type: 'loop',
            gap: '4rem',
            focus: 'center',
            pagination: false,
            arrows: false,
            autoWidth: true,
            autoScroll: {
                speed: 2,
            },
            breakpoints: {
                1200: {
                    perPage: 4
                },
                767: {
                    perPage: 2
                },
            }
        }).mount({ AutoScroll: splide_extension_auto_scroll_1.AutoScroll });
    }
    let ticker = document.getElementsByClassName('ticker-slider');
    for (let i = 0; i < ticker.length; i++) {
        new splide_1.default(ticker[i], {
            perPage: 1,
            type: 'loop',
            gap: '20px',
            autoWidth: true,
            pagination: false,
            arrows: false,
            autoScroll: {
                speed: 0.5,
            },
        }).mount({ AutoScroll: splide_extension_auto_scroll_1.AutoScroll });
    }
    let caseStudies = document.getElementsByClassName('case-studies__slider');
    for (let i = 0; i < caseStudies.length; i++) {
        new splide_1.default(caseStudies[i], {
            perPage: 3,
            type: 'loop',
            gap: '20px',
            pagination: true,
            arrows: true,
            autoplay: true,
            breakpoints: {
                1200: {
                    perPage: 2
                },
                767: {
                    perPage: 1
                },
            }
        }).mount();
    }
    let postsGrid = document.getElementsByClassName('posts-grid__slider');
    for (let i = 0; i < postsGrid.length; i++) {
        const slides = postsGrid[i].querySelectorAll('.splide__slide');
        new splide_1.default(postsGrid[i], {
            perPage: 4,
            type: slides.length > 4 ? "loop" : 'slide',
            gap: 20,
            arrows: slides.length > 4 ? true : false,
            breakpoints: {
                1000: {
                    perPage: 3,
                },
                800: {
                    perPage: 2,
                },
                600: {
                    perPage: 1,
                },
            },
        }).mount();
    }
};
exports.sliders = sliders;
